
export const PUBLIC_PLAYLIST_TEXT = 'Share your learning resources with the LangMagic community to enhance collective knowledge and experiences in language learning.';
export const PUBLIC_PROFILE_TEXT = 'Enabling this setting will prompt you to create a public profile.';
